import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row row-cols-2" }
const _hoisted_2 = { class: "row row-cols-2" }
const _hoisted_3 = { class: "row row-cols-2" }
const _hoisted_4 = { class: "row row-cols-2" }
const _hoisted_5 = { class: "row row-cols-2" }
const _hoisted_6 = { class: "row row-cols-2" }
const _hoisted_7 = { class: "dialog-footer" }

import { ref, watch } from "vue";
import i18n from "@/core/plugins/i18n";
import AccountService from "../../services/AccountService";
import {
  AccountRoleTypes,
  AccountStatusTypes,
} from "@/core/types/AccountInfos";
import { ConfigSiteTypesSelections } from "@/core/types/SiteTypes";
import { ElNotification } from "element-plus";
import { ReportRequestTypes } from "@/core/types/ReportRequestTypes";
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportAccounts',
  setup(__props, { expose: __expose }) {

const t = i18n.global.t;
const isLoading = ref(false);
const dialogRef = ref(false);
const criteria = ref({} as any);
const createdAtRange = ref<any>(null);

const currentDate = moment().format("YYYY-MM-DD");

const ServiceList = ref<any>([
  { label: "-- All --", value: "" },
  { label: "No Server", value: 0 },
  { label: "BCRCO-Real", value: 10 },
  { label: "BCR-Real", value: 20 },
  { label: "BCR-MT5", value: 30 },
]);

const show = (_criteria: any) => {
  dialogRef.value = true;
  criteria.value = {
    searchText: _criteria.searchText,
    includeClosed: _criteria.includeClosed,
    serviceId: _criteria.serviceId,
    status: _criteria.status,
    siteId: _criteria.siteId,
    role: _criteria.role,
    parentAccountUid: _criteria.parentAccountUid,
    salesUid: _criteria.salesUid,
    group: _criteria.group,
    code: _criteria.code,
    from: _criteria.from,
    to: _criteria.to,
  };
  if (_criteria.from && _criteria.to) {
    createdAtRange.value = [_criteria.from, _criteria.to];
  } else {
    createdAtRange.value = null;
  }
};

watch(createdAtRange, (val) => {
  if (val && val.length === 2) {
    criteria.value.from = val[0];
    criteria.value.to = val[1];
  } else {
    criteria.value.from = null;
    criteria.value.to = null;
  }
});

const exportAccounts = async () => {
  isLoading.value = true;
  try {
    await AccountService.exportAccounts({
      type: ReportRequestTypes.AccountSearchForTenant,
      name: "Accounts Report-" + currentDate,
      query: criteria.value,
    });
    ElNotification.success({
      title: "Success",
      message: "Exporting accounts report success",
    });
    criteria.value = {};
    createdAtRange.value = null;
  } catch (e) {
    console.error(e);
    ElNotification.error({
      title: "Error",
      message: e.message,
    });
  } finally {
    isLoading.value = false;
  }
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((dialogRef).value = $event)),
    title: _ctx.$t('action.export'),
    width: "900",
    "align-center": ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_button, {
          onClick: _cache[11] || (_cache[11] = ($event: any) => (dialogRef.value = false)),
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "success",
          loading: isLoading.value,
          onClick: _cache[12] || (_cache[12] = ($event: any) => (exportAccounts()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.export")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, { "label-width": "auto" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('tip.searchKeyWords')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: criteria.value.searchText,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.searchText) = $event)),
                  clearable: "",
                  disabled: isLoading.value
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('status.showClosedAccount')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: criteria.value.includeClosed,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria.value.includeClosed) = $event)),
                  size: "large",
                  disabled: isLoading.value
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_form_item, { label: "MT" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "w-150px",
                  modelValue: criteria.value.serviceId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((criteria.value.serviceId) = $event)),
                  disabled: isLoading.value
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ServiceList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('fields.status')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "w-150px",
                  modelValue: criteria.value.status,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((criteria.value.status) = $event)),
                  disabled: isLoading.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "-- All --",
                      value: ""
                    }),
                    _createVNode(_component_el_option, {
                      label: "Activated",
                      value: _unref(AccountStatusTypes).Activate
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      label: "Paused",
                      value: _unref(AccountStatusTypes).Pause
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      label: "Inactivated",
                      value: _unref(AccountStatusTypes).Inactivated
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.site')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "w-150px",
                  modelValue: criteria.value.siteId,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((criteria.value.siteId) = $event)),
                  disabled: isLoading.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "-- All --",
                      value: ""
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigSiteTypesSelections), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.role')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "w-150px",
                  modelValue: criteria.value.role,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((criteria.value.role) = $event)),
                  disabled: isLoading.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "-- All --",
                      value: ""
                    }),
                    _createVNode(_component_el_option, {
                      label: "Client",
                      value: _unref(AccountRoleTypes).Client
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      label: "IB",
                      value: _unref(AccountRoleTypes).IB
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      label: "Sales",
                      value: _unref(AccountRoleTypes).Sales
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_form_item, { label: "Child Accounts" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "w-150px",
                  modelValue: criteria.value.parentAccountUid,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((criteria.value.parentAccountUid) = $event)),
                  disabled: isLoading.value,
                  clearable: ""
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Sales Child Only" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "w-150px",
                  modelValue: criteria.value.salesUid,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((criteria.value.salesUid) = $event)),
                  clearable: "",
                  disabled: isLoading.value
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.ibGroup')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "w-150px",
                  modelValue: criteria.value.group,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((criteria.value.group) = $event)),
                  clearable: "",
                  disabled: isLoading.value
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.salesCode')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "w-150px",
                  modelValue: criteria.value.code,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((criteria.value.code) = $event)),
                  clearable: "",
                  disabled: isLoading.value
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.created_at')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: createdAtRange.value,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((createdAtRange).value = $event)),
                  type: "daterange",
                  "start-placeholder": _ctx.$t('fields.startDate'),
                  "end-placeholder": _ctx.$t('fields.endDate'),
                  "value-format": "YYYY-MM-DD",
                  class: "w-250px",
                  clearable: "",
                  disabled: isLoading.value
                }, null, 8, ["modelValue", "start-placeholder", "end-placeholder", "disabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})